export default {
  title: 'Klik eller træk fil hertil for at uploade',
  description: 'Understøtter i øjeblikket formaterne .csv, .xls, .xlsx',
  buttons: {
    download_template: 'Download importskabelon',
  },
  toasts: {
    error: 'Filen kunne ikke uploades',
  },
};
